import PoliciesTemplate from "../../../templates/admin/policies";

const PoliciesScreen = () => {
  return <PoliciesTemplate />;
};

export default PoliciesScreen;
